import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    getStaffMembers: {
        email: string,
        id: string,
        name: string,
        role: 'STAFF' | 'ADMIN',
    }[]
}

export const GET_USERS: TypedDocumentNode<Result> = gql`
    query GetStaffMembers {
        getStaffMembers {
            email
            id
            name
            role
        }
    }       
`
